import { getBackendUrl } from '../env'

export const updateUser = async(user:any) =>{
    const response = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
        method: 'PATCH',
        body: JSON.stringify(user),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        }
      })
      return response
}

export const getUserInfo = async(user:any) =>{
    const response = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        }
      })
      return response
}